var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.active)?_c('div',{staticClass:"loader-wrapper"},[_vm._m(0),_c('p',[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader"},[_c('div'),_c('div'),_c('div'),_c('div')])
}]

export { render, staticRenderFns }